import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { CALENDLY_URL, LOGO_URL, INSTAGRAM_URL } from '../lib/siteConfig';

/**
 * Public /contact route (Phase 35).
 *
 * Wraps the existing ContactSection component (form + Call Front Desk card
 * + Discovery Call card + Instagram tile) with the standard Navbar/Footer
 * shell so the Contact page is a discoverable, linkable destination
 * (footer "Contact" links here, IG bio links here, etc.).
 *
 * No new business logic — this page is composition only. All routing into
 * `tel:` and Calendly is handled by the ContactSection component itself.
 */
export default function Contact() {
  useEffect(() => {
    document.title = 'Contact — Apex Athletic Mind';
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0d0e] text-white" data-testid="contact-page">
      <Navbar calendlyLink={CALENDLY_URL} logoUrl={LOGO_URL} />
      <main id="main-content">
        <ContactSection calendlyLink={CALENDLY_URL} instagramLink={INSTAGRAM_URL} />
      </main>
      <Footer
        calendlyLink={CALENDLY_URL}
        instagramLink={INSTAGRAM_URL}
        logoUrl={LOGO_URL}
      />
    </div>
  );
}
